(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eleven-articulo"]) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      var art = (raiz || document).querySelector('[data-ev-articulo]');
      if (!art || art.dataset.evListo) return;
      art.dataset.evListo = '1';
      var contenido = art.querySelector('[data-ev-contenido]');
      var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Tarjetas de producto dentro del texto, si el artículo marca el lugar
      var destino = contenido && contenido.querySelector('[data-ev-productos-aqui]');
      var productos = art.querySelector('[data-ev-productos]');
      if (destino && productos) destino.replaceWith(productos);

      // Índice automático con los h2
      var indice = art.querySelector('[data-ev-indice]');
      var lista = art.querySelector('[data-ev-indice-lista]');
      var titulos = contenido ? Array.prototype.slice.call(contenido.querySelectorAll('h2:not(.ev-seccion-titulo)')) : [];
      if (indice && lista && titulos.length >= 3) {
        titulos.forEach(function (h, i) {
          if (!h.id) {
            h.id = (h.textContent || 'seccion')
              .toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
              .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') + '-' + (i + 1);
          }
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          lista.appendChild(li);
        });
        indice.hidden = false;
        if ('IntersectionObserver' in window) {
          var enlaces = lista.querySelectorAll('a');
          var vigia = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (e) {
              if (e.isIntersecting) {
                enlaces.forEach(function (l) { l.classList.toggle('ev-activo', l.getAttribute('href') === '#' + e.target.id); });
              }
            });
          }, { rootMargin: '-20% 0px -70% 0px' });
          titulos.forEach(function (h) { vigia.observe(h); });
        }
      }

      // Barra de progreso de lectura
      var barra = document.querySelector('[data-ev-progreso]');
      if (barra) {
        var pendiente = false;
        var actualizar = function () {
          pendiente = false;
          var caja = art.getBoundingClientRect();
          var total = caja.height - window.innerHeight;
          var avance = total > 0 ? Math.min(Math.max(-caja.top / total, 0), 1) : 1;
          barra.style.transform = 'scaleX(' + avance + ')';
        };
        window.addEventListener('scroll', function () {
          if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
        }, { passive: true });
        actualizar();
      }

      // Aparición suave al bajar
      if (!sinMovimiento && 'IntersectionObserver' in window) {
        if (contenido) {
          contenido.querySelectorAll('h2:not(.ev-seccion-titulo), figure, .ev-tip, .ev-alerta, .ev-dato, .ev-pasos, .ev-comparar, table').forEach(function (el) {
            el.classList.add('ev-revelar');
          });
        }
        art.classList.add('ev-anim');
        var aparecer = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('ev-visible'); aparecer.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px' });
        art.querySelectorAll('.ev-revelar').forEach(function (el) { aparecer.observe(el); });
      }

      // Copiar enlace
      var copiar = art.querySelector('[data-ev-copiar]');
      if (copiar) {
        copiar.addEventListener('click', function () {
          var texto = copiar.getAttribute('data-ev-copiar');
          if (navigator.clipboard) {
            navigator.clipboard.writeText(texto).then(function () {
              copiar.textContent = '¡Copiado!';
              setTimeout(function () { copiar.textContent = 'Copiar enlace'; }, 1800);
            });
          }
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
